import Fullpage from './components/Fullpage';
import Slide from './components/Slide';
import HorizontalSlider from './components/HorizontalSlider';

export {
  Fullpage,
  Slide,
  HorizontalSlider
};



// WEBPACK FOOTER //
// ./lib/index.js